export default __webpack_public_path__ + "static/media/snkrep-app-icon.51e7883f.png";